module.exports = __webpack_public_path__ + "img/1487842584.626de5bb.jpg";